import React, { component, useState, useEffect } from 'react';
import Slideshow from './components/Slideshow';
import { HashRouter, Switch, Route } from 'react-router-dom';
import About from './components/About';
import Landing from './components/Landing';
import Letter from './components/Letter';
import ArticleGrid from './components/ArticleGrid';
import { AnimatedSwitch } from 'react-router-transition';
import ReactGA from 'react-ga';
import Map from './components/Map';
import SeniorAdvice from './components/senior_advice/SeniorAdvice';
import ScrollToTop from './components/ArticleGrid/ScrollToTop'
import StoriesPage from './components/ArticleGrid'

import GifWithLanding from './components/GifWithLanding';


function initializeReactGA() {
  ReactGA.initialize('UA-28181852-32');
  ReactGA.pageview('/homepage');
}

function App() {
  initializeReactGA();
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(
      'https://kerckhoff.dailybruin.com/api/packages/flatpages/interactive.2021.grad-issue'
    )
      .then((res) => res.json())
      .then((res) => setData(res.data['article.aml']));
  }, []);

  // const gradissueData = JSON.parse(data)
  // console.log(gradissueData)

  return (
    <HashRouter>
      <AnimatedSwitch>
        <Route exact path="/" render={() => <GifWithLanding data={data} />} />
        <Route exact path="/home" render={() => <Landing />} />
        
        <Route path="/stories" render={() => <StoriesPage data={data} />} />
        <Route path="/letter" render={() => <Letter data={data} />} />
        <Route
          path="/year-in-review"
          render={() => <Slideshow data={data} />}
        />
        <Route path="/about" render={() => <About data={data} />} />
        <Route path="/map" render={() => <Map />} />
        <Route path="/advice" render={() => <SeniorAdvice />} />
      </AnimatedSwitch>
    </HashRouter>
  );
}

export default App;
